export type AccessSortKey = 'user' | 'email' | 'added'
export type AccessSortOrder = 'asc' | 'desc'

interface Sortable {
  principalName: string
  principalEmail: string | null
  grantedAt: string | null
}

export function sortAccessPermissions<T extends Sortable>(
  permissions: T[],
  sortBy: AccessSortKey,
  order: AccessSortOrder
): T[] {
  const dir = order === 'asc' ? 1 : -1
  return [...permissions].sort((a, b) => {
    if (sortBy === 'added') {
      const at = a.grantedAt ? Date.parse(a.grantedAt) : 0
      const bt = b.grantedAt ? Date.parse(b.grantedAt) : 0
      return (at - bt) * dir
    }
    if (sortBy === 'email') {
      return (a.principalEmail ?? '').localeCompare(b.principalEmail ?? '') * dir
    }
    return a.principalName.localeCompare(b.principalName) * dir
  })
}
